import { IConstraintWaterSupply } from '../../interfaces/iconstraint-water-supply';
import { Area } from '../area';
import { Scenario } from '../scenario';

export class ConstraintWaterSupplyBase {
  ConstraintWaterSupplyId: number;
  ScenarioId: number;
  WaterNetworkAreaId: number | null;
  CurrentInventory: number | null;
  MaximumRefillRate: number | null;
  Buffer: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  MinimumInventory: number | null;
  MaximumInventory: number | null;
  Scenario?: Scenario;
  Area?: Area;

  constructor(item?: IConstraintWaterSupply) {
    if (item) {
      this.ConstraintWaterSupplyId = item.ConstraintWaterSupplyId;
      this.ScenarioId = item.ScenarioId;
      this.WaterNetworkAreaId = item.WaterNetworkAreaId;
      this.CurrentInventory = item.CurrentInventory;
      this.MaximumRefillRate = item.MaximumRefillRate;
      this.Buffer = item.Buffer;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.Scenario = new Scenario(item.Scenario);
      this.Area = new Area(item.Area);
      this.MinimumInventory = item.MinimumInventory;
      this.MaximumInventory = item.MaximumInventory;
    }
  }
}